// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-setting--messenger-channels .checkbox-list{display:none;margin-left:17px;overflow:hidden}.custom-setting--messenger-channels .checkbox-list.is-selected-list{display:block}", ""]);
// Exports
module.exports = exports;
